import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/users/store';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageUsersStore() {
  return (
    <Root title={PAGE_TITLE.USERS_STORE}>
      <Container>
        <Component />
      </Container>
    </Root>
  );
};
